module.exports = __webpack_public_path__ + "assets/img/free_19.ebd7efb3.png";